<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <TermsAndConditions
      :open-modal="openModal"
      :orp-details="prpDetails"
      @close-modal="closeTermsAndConditions()"
    />
    <form
      v-if="!isSuccess"
      id="login-form"
      class="login-form custom-form"
      novalidate
      @submit.prevent="handleSubmit(onSubmit)"
    >
      <div
        class="row success-message text-center m-b-20"
      >
        <h1
          class="title md-title"
        >
          <span class="publisher-registration-welcome-message" />
        </h1>
        <p
          v-if="prpDetails.description"
          class="subtitle p-t-10 p-b-10"
        >
          {{ prpDetails.description }}
        </p>
        <p
          v-t="'PRP_SUB_HEADER'"
          class="subtitle p-b-15"
        />
      </div>
      <ValidationProvider
        v-slot="{ errors }"
        rules="required"
      >
        <fieldset
          class="login-form__field input__wrap"
          :class="{ 'error-focus': errors.length > 0 }"
        >
          <input
            id="companyName"
            v-model="companyName"
            type="text"
            name="companyName"
            class="login-form__field__input required"
            :class="{
              error: errors.length > 0,
              valid: companyName.length > 0 && errors.length == 0,
            }"
            required
          >
          <label
            v-t="'INPUT_BUSINESS_NAME'"
            for="companyName"
            class="login-form__field__label"
          />
          <div
            v-if="errors.length > 0"
            class="error-tooltip__wrap"
          >
            <h4
              v-t="'INPUT_BUSINESS_NAME_ERROR'"
              class="menu-link up-text error-tooltip__content"
            />
            <p
              v-t="'INPUT_BUSINESS_NAME_ERROR_DESCRIPTION'"
              class="description"
            />
          </div>
        </fieldset>
      </ValidationProvider>
      <ValidationProvider
        v-slot="{ errors }"
        rules="required"
      >
        <fieldset
          class="login-form__field input__wrap"
          :class="{ 'error-focus': errors.length > 0 }"
        >
          <input
            id="firstName"
            v-model="firstName"
            type="text"
            name="firstName"
            class="login-form__field__input required"
            :class="{
              error: errors.length > 0,
              valid: firstName.length > 0 && errors.length == 0,
            }"
            required
          >
          <label
            v-t="'INPUT_FIRST_NAME'"
            for="firstName"
            class="login-form__field__label"
          />
          <div
            v-if="errors.length > 0"
            class="error-tooltip__wrap"
          >
            <h4
              v-t="'INPUT_FIRST_NAME_ERROR'"
              class="menu-link up-text error-tooltip__content"
            />
            <p
              v-t="'INPUT_FIRST_NAME_ERROR_DESCRIPTION'"
              class="description"
            />
          </div>
        </fieldset>
      </ValidationProvider>
      <ValidationProvider
        v-slot="{ errors }"
        rules="required"
      >
        <fieldset
          class="login-form__field input__wrap"
          :class="{ 'error-focus': errors.length > 0 }"
        >
          <input
            id="lastName"
            v-model="lastName"
            type="text"
            name="lastName"
            class="login-form__field__input required"
            :class="{
              error: errors.length > 0,
              valid: lastName.length > 0 && errors.length == 0,
            }"
            required
          >
          <label
            v-t="'INPUT_LAST_NAME'"
            for="lastName"
            class="login-form__field__label"
          />
          <div
            v-if="errors.length > 0"
            class="error-tooltip__wrap"
          >
            <h4
              v-t="'INPUT_LAST_NAME_ERROR'"
              class="menu-link up-text error-tooltip__content"
            />
            <p
              v-t="'INPUT_LAST_NAME_ERROR_DESCRIPTION'"
              class="description"
            />
          </div>
        </fieldset>
      </ValidationProvider>
      <ValidationProvider
        v-slot="{ errors }"
        rules="required|email"
      >
        <fieldset
          class="login-form__field input__wrap"
          :class="{ 'error-focus': errors.length > 0 }"
        >
          <input
            id="email"
            ref="emailInput"
            v-model="email"
            type="email"
            name="email"
            class="login-form__field__input required"
            :class="{
              error: errors.length > 0,
              valid: email.length > 0 && errors.length == 0,
            }"
            required
          >
          <label
            v-t="'INPUT_EMAIL'"
            for="email"
            class="login-form__field__label"
          />
          <div
            v-if="errors.length > 0"
            class="error-tooltip__wrap"
          >
            <h4
              v-t="'INPUT_EMAIL_ERROR'"
              class="menu-link up-text error-tooltip__content"
            />
            <p
              v-t="'INPUT_EMAIL_ERROR_DESCRIPTION'"
              class="description"
            />
          </div>
        </fieldset>
      </ValidationProvider>
      <ValidationProvider
        v-slot="{ errors }"
      >
        <fieldset
          class="login-form__field input__wrap"
          :class="{ 'error-focus': errors.length > 0 }"
        >
          <input
            id="phoneNumber"
            v-model="phoneNumber"
            type="text"
            name="phoneNumber"
            class="login-form__field__input required"
            :class="{
              error: errors.length > 0,
              valid: phoneNumber.length > 0 && errors.length == 0,
            }"
          >
          <label
            v-t="'INPUT_PHONE_NUMBER'"
            for="phoneNumber"
            class="login-form__field__label"
          />
          <div
            v-if="errors.length > 0"
            class="error-tooltip__wrap"
          >
            <h4
              v-t="'INPUT_PHONE_NUMBER_ERROR'"
              class="menu-link up-text error-tooltip__content"
            />
            <p
              v-t="'INPUT_PHONE_NUMBER_ERROR_DESCRIPTION'"
              class="description"
            />
          </div>
        </fieldset>
      </ValidationProvider>
      <ValidationProvider
        v-if="prpDetails.requireAgreementToTerms"
        v-slot="{ errors }"
        :rules="{ required: { allowFalse: false } }"
      >
        <fieldset
          class="login-form__field login-form__field--checkbox checkbox__wrap"
        >
          <input
            id="tos.checkbox"
            v-model="agreedToTerms"
            type="checkbox"
            name="tos.checkbox"
            class="login-form__field__input--checkbox"
          >
          <label
            for="tos.checkbox"
            class="login-form__field__label login-form__field__label--checkbox"
          >

            <span v-if="prpDetails.isTermsAndConditionsURL">
              {{ $t("PRP_TERMS_PREFIX") }}&nbsp;&nbsp;<a
                :href="getTermsAndConditionsUrl"
                target="_BLANK"
              ><u>{{ $t("PRP_TERMS_LINK") }}</u></a>
            </span>
            <span v-if="!prpDetails.isTermsAndConditionsURL">
              {{ $t("PRP_TERMS_PREFIX") }}&nbsp;&nbsp;<a
                href="javascript:;"
                @click="openTermsAndConditions()"
              ><u>{{ $t("PRP_TERMS_LINK") }}</u></a>
            </span>

          </label>
          <transition name="backend-error-fade">
            <div
              v-show="errors.length > 0"
              class="text-center p-t-5"
            >
              <p
                v-t="'TERMS_EROR'"
                class="text-danger"
              />
            </div>
          </transition>
        </fieldset>
      </ValidationProvider>
      <fieldset class="login-form__field login-form__field--button p-t-15">
        <SubmitButton :pending="isPending">
          {{ $t('PRP_REGISTER_BUTTON') }}
        </SubmitButton>
      </fieldset>
      <transition name="backend-error-fade">
        <div
          v-show="showErrorMsg"
          class="text-center p-t-5"
        >
          <p class="text-danger">
            {{ actionStatus.error !== '' ? actionStatus.error: $t('ORP_GENERIC_ERROR', { applicantType }) }}
          </p>
        </div>
      </transition>
      <div>
        <p
          class="text-center p-t-15 prp_footer_contact"
          v-html="$t('ORP_FOOTER_CONTACT_EMAIL', { contactEmail: prpDetails.contactEmail, applicantType })"
        />
      </div>
    </form>
    <div
      v-if="isSuccess"
      class="success-message text-center"
    >
      <h1
        v-t="'PRP_THANK_YOU_HEADER'"
        class="title md-title"
      />
      <p
        v-t="'PRP_THANK_YOU_LINE1'"
        class="subtitle"
      />
      <p
        v-t="'ORP_THANK_YOU_LINE2'"
        class="subtitle"
      />
    </div>
  </ValidationObserver>
</template>

<script>

import messages from '../../locales';
import { STATUS_PENDING, STATUS_ERROR, STATUS_SUCCESS } from '@/store/helpers';
import SubmitButton from '@/modules/auth/components/SubmitButton';
import TermsAndConditions from '../TermsAndConditions';

export default {
  components: {
    SubmitButton,
    TermsAndConditions
  },
  props: {
    actionStatus: {
      type: Object,
      default() {
        return {};
      },
    },
    prpDetails: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: function () {
    return {
      email: '',
      firstName: '',
      lastName: '',
      companyName: '',
      phoneNumber: '',
      agreedToTerms: false,
      openModal: false,
      applicantType: 'publisher'
    };
  },
  computed: {
    isPending() {
      return this.actionStatus.status === STATUS_PENDING;
    },
    isSuccess() {
      return this.actionStatus.status === STATUS_SUCCESS;
    },
    showErrorMsg() {
      return this.actionStatus.status === STATUS_ERROR;
    },
    getTermsAndConditionsUrl() {
      return this.prpDetails.termsAndConditions || '//www.ringba.com/terms';
    }
  },
  methods: {
    onSubmit() {
      const { email, firstName, lastName, companyName, phoneNumber, agreedToTerms  } = this;
      this.$emit('on-register', { email, firstName, lastName, companyName, phoneNumber, agreedToTerms });
    },
    openTermsAndConditions() {
      this.openModal = true;
    },
    closeTermsAndConditions() {
      this.openModal = false;
    }
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style>
.modal.prp-terms-modal .modal-content {
  border-radius: 20px;
  background: var(--component-publisher-registration__center-bg);
}
</style>